// Shared monotonic counters used both by Game.jsx and the useGameEngine hook
// so that call IDs and dispatch IDs are globally unique within the session.
let CALL_ID = 1;
let DISPATCH_ID = 1;

export function nextCallId() {
  return CALL_ID++;
}

export function nextDispatchId() {
  return DISPATCH_ID++;
}

// Used on initial state restore to bump the counters past any IDs we've seen.
export function bumpCallIdAtLeast(n) {
  if (n + 1 > CALL_ID) CALL_ID = n + 1;
}

export function bumpDispatchIdAtLeast(n) {
  if (n + 1 > DISPATCH_ID) DISPATCH_ID = n + 1;
}
